import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';


import './articles/Articles.css';
import ArticleForm from './articles/ArticleForm';
import ArticleList from './articles/ArticleList';
import { fetchArticles, createArticle, deleteArticle } from '../services/articles';

const AdminPortal = () => {

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch articles on component mount
  useEffect(() => {
    loadArticles();
  }, []);

  const loadArticles = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchArticles();
      setArticles(data);
    } catch (err) {
      setError('Failed to load articles. Make sure the backend server is running.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddArticle = async (article) => {
    try {
      console.log('Create article:', article);
      const newArticle = await createArticle(article);
      setArticles([newArticle, ...articles]);
      setError(null);
    } catch (err) {
      setError('Failed to create article. Please try again.');
      console.error(err);
      throw err; // Re-throw to let the form handle it
    }
  };

  const handleDeleteArticle = async (id) => {
    if (!window.confirm('Are you sure you want to delete this article?')) {
      return;
    }
    
    try {
      await deleteArticle(id);
      setArticles(articles.filter(article => article._id !== id));
      setError(null);
    } catch (err) {
      setError('Failed to delete article. Please try again.');
      console.error(err);
    }
  };



  return (
    <>
      <Box sx={{ height: '80px' }}></Box>
      {/* <div>

        <Box height={80} />

          <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={2} />
                <Grid item xs={8}>
                    <Card>
                    <CardHeader title='网站管理页面'/>
                    <CardContent>
                      <Box textAlign={'center'}>
                        <Typography>
                          网站管理页面内容
                        </Typography>
                      </Box>
                    </CardContent>
                    </Card>

                </Grid> 
                <Grid item xs={2} />
            </Grid>
      
      </div> */}

      <div>
        <div >
          {/* <header className="App-header">
            <h1>📝 Article Manager</h1>
            <p>Create and share your articles</p>
          </header> */}

          {/* {error && (
            <div className="error-banner">
              ⚠️ {error}
              <button onClick={loadArticles} className="retry-btn">🔄 Retry</button>
            </div>
          )} */}
        </div>

        <div className="container">
          <div className="form-section">
            <ArticleForm onAddArticle={handleAddArticle} />
          </div>
          
          <div className="articles-section">
            <h2>Published Articles</h2>
            {loading ? (
              <div className="loading">Loading articles...</div>
            ) : (
              <ArticleList articles={articles} onDeleteArticle={handleDeleteArticle} />
            )}
          </div>
        </div>
      </div> 

       <Box sx={{ height: '80px' }}></Box>
    </>
  )
}

export default AdminPortal